{
  "name": "extract-youtube",
  "version": "1.0.253",
  "description": "Fast, no-browser serverless-optimized YouTube transcript extractor",
  "main": "dist/index.cjs",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs",
      "types": "./dist/index.d.ts"
    }
  },
  "bin": "dist/cli.js",
  "scripts": {
    "build": "npm run build:types && npm run build:lib && npm run build:cli",
    "build:types": "tsc --emitDeclarationOnly --declaration --declarationMap",
    "build:lib": "vite build",
    "build:cli": "BUILD_CLI=true vite build",
    "build:bundle": "npm run build:lib && npm run build:cli",
    "build:legacy": "tsc",
    "prepare": "npm run build",
    "ship": "npx standard-version --release-as patch; npm publish",
    "test": "jest",
    "test:coverage": "jest --coverage",
    "test:speeds": "bun src/cli.ts dQw4w9WgXcQ -f speeds",
    "lint": "eslint src --ext .ts"
  },
  "keywords": [
    "youtube",
    "transcript",
    "subtitles",
    "captions",
    "api",
    "serverless",
    "lambda",
    "vercel",
    "cloudflare",
    "edge",
    "typescript",
    "youtube-transcript",
    "youtube-transcript-api",
    "srt",
    "webvtt",
    "video",
    "parsing",
    "extraction",
    "optimized"
  ],
  "author": "",
  "license": "rights.institute/PROSPER",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/OpenSourceAGI/qwksearch-research-agent.git",
    "directory": "packages/extract-youtube"
  },
  "dependencies": {
    "fast-xml-parser": "^4.2.5",
    "html-entities": "^2.3.3",
    "https-proxy-agent": "^7.0.6",
    "grab-url": "^1.6.19",
    "youtube-transcript-api": "^3.0.6"
  },
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "@types/node": ">=22.12.0",
    "jest": "^29.5.0",
    "terser": "^5.46.0",
    "ts-jest": "^29.1.0",
    "typescript": "^5.0.0",
    "vite": "^8.0.0"
  },
  "engines": {
    "node": ">=14.0.0"
  }
}